const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001'

// Uses XHR (not fetch) specifically to get upload progress events —
// fetch's request-body streaming progress isn't reliably exposed across
// browsers yet, XHR's progress event is the tried-and-true way.
export const uploadFileShare = (file, maxDownloads, ttlHours, onProgress) =>
  new Promise((resolve, reject) => {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('maxDownloads', String(maxDownloads))
    formData.append('ttlHours', String(ttlHours))

    const xhr = new XMLHttpRequest()
    xhr.open('POST', `${API_URL}/api/file-shares`)

    xhr.upload.onprogress = (event) => {
      if (event.lengthComputable && onProgress) onProgress(event.loaded / event.total)
    }
    xhr.onload = () => {
      let data = {}
      try {
        data = JSON.parse(xhr.responseText)
      } catch {
        // ignore, handled by the status check below
      }
      if (xhr.status >= 200 && xhr.status < 300) {
        resolve(data)
      } else {
        reject(new Error(data.message || 'Não foi possível enviar o arquivo agora.'))
      }
    }
    xhr.onerror = () => reject(new Error('Não foi possível enviar o arquivo agora.'))
    xhr.send(formData)
  })

export const fetchFileShareInfo = async (id) => {
  const response = await fetch(`${API_URL}/api/file-shares/${id}/info`)
  if (!response.ok) return null
  return response.json()
}

export const fileShareDownloadUrl = (id) => `${API_URL}/api/file-shares/${id}`

export const deleteFileShare = async (id, ownerToken) => {
  const response = await fetch(`${API_URL}/api/file-shares/${id}`, {
    method: 'DELETE',
    headers: { 'x-owner-token': ownerToken },
  })
  if (!response.ok) {
    const data = await response.json().catch(() => ({}))
    throw new Error(data.message || 'Não foi possível excluir o arquivo agora.')
  }
  return response.json()
}
